import { GameWorkerTaskTypes } from '@a/store/game/types';
import { CloudUnitType, CloudUnitTypeName } from '@a/store/product/types';
import VueI18Next from '@panter/vue-i18next';
import { Mod, ModTag, ModTagGroup } from './types';

export const useBaseModpackSearch = (
  props: {isShowRam: boolean, ramUnitType: CloudUnitType, },
  i18n: VueI18Next,
  getters: unknown,
) => {
  const labelFunction = props.isShowRam
    ? (mod: Mod) => {
      if (mod == null) return null;
      if (mod.ram != null && mod.ram > 0) {
        let ramValue: number = mod.ram;
        let ramUnitTypeLocoKey: string = mod.unit;
        if (mod.unit === 'MB' && props.ramUnitType.name === CloudUnitTypeName.GB) {
          ramValue = mod.ram / 1024;
          ramUnitTypeLocoKey = props.ramUnitType.loco_key;
        }

        return `${mod.name} (${i18n.t('general:ram.units.recommended', { units: ramValue, unitName: i18n.t(ramUnitTypeLocoKey) })})`;
      }

      return mod.name;
    }
    : (mod: Mod) => mod.name;

  const groupLabelFunction = (tag: ModTag) => i18n.t(`${tag.translation_key.namespace}:${tag.translation_key.key}`);

  const filterModsByPhrase = async (
    tags: Array<ModTag>,
    query: string,
  ): Promise<Array<ModTagGroup>> => new Promise((resolve) => {
    const worker = (getters['game/worker'] as Worker);
    worker.postMessage({ task: GameWorkerTaskTypes.FILTER_MODS_BY_QUERY, input: { tags, query } });

    worker.onmessage = (event: MessageEvent) => {
      resolve(event.data);
    };
  });

  return {
    filterModsByPhrase,
    labelFunction,
    groupLabelFunction,
  };
};
